/**
 * ResetPassword2.jsx
 * Tatalli Cloud — Şifre Sıfırlama Adım 2 (OTP + Yeni Şifre)
 * Layout: src/Layouts/Shared/_AuthLayout.jsx
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import AuthLayout from '../../Layouts/Shared/_AuthLayout';

const LEFT_FEATURES = [
  { ikon: 'fa-shield-alt', key: 'auth.tip.strong-password' },
  { ikon: 'fa-font',       key: 'auth.tip.uppercase' },
  { ikon: 'fa-hashtag',    key: 'auth.tip.numbers' },
];

export default function ResetPassword2() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [email, setEmail]                     = useState('');
  const [otp, setOtp]                         = useState('');
  const [yeniSifre, setYeniSifre]             = useState('');
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState('');
  const [sifreGoster, setSifreGoster]         = useState(false);
  const [yukleniyor, setYukleniyor]           = useState(false);
  const [hata, setHata]                       = useState('');

  const handleGuncelle = async (e) => {
    if (e) e.preventDefault();
    setHata('');
    if (yeniSifre !== yeniSifreTekrar) {
      setHata(t('pages.register.form-notification.validation.is-not-equal-new-password-and-new-confirm-password'));
      return;
    }
    setYukleniyor(true);
    try {
      const ApiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.put(`${ApiUrl}/access/login/reset-password`, {
        email, otp, newPassword: yeniSifre, newPasswordAgain: yeniSifreTekrar,
      });
      const data = response.data;
      if (data?.isSucceed) {
        toast.success(t('api.default.service.response.succeded'));
        setTimeout(() => navigate('/portal/login'), 1200);
      } else {
        const msg = data?.messages?.[0]?.message;
        setHata(msg || t('api.default.service.response.error'));
        setYukleniyor(false);
      }
    } catch {
      toast.error(t('api.default.service.response.error'));
      setYukleniyor(false);
    }
  };

  return (
    <AuthLayout
      titleKey="pages.reset-password-2.title"
      leftHeadlineKey="auth.new-password.headline"
      leftSloganKey="header.slogan"
      leftDescKey="auth.new-password.description"
      leftFeatures={LEFT_FEATURES}
    >
      <div className="auth-form-konteyner">

        <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
          <Link
            to="/reset-password-1"
            style={{ color: '#9ca3af', transition: 'color 0.15s', lineHeight: 1 }}
            onMouseOver={e => e.currentTarget.style.color = '#013682'}
            onMouseOut={e => e.currentTarget.style.color = '#9ca3af'}
          >
            <i className="fas fa-arrow-left" />
          </Link>
          <h2 className="auth-form-baslik" style={{ marginBottom: 0 }}>
            {t('pages.reset-password-2.header')}
          </h2>
        </div>
        <p className="auth-form-aciklama">
          {t('pages.reset-password-2.description')}
        </p>

        {hata && (
          <div className="auth-hata-kutusu">
            <i className="fas fa-exclamation-circle" />
            <span>{hata}</span>
          </div>
        )}

        <form onSubmit={handleGuncelle}>

          {/* E-posta */}
          <div className="form-grubu">
            <label className="form-etiketi">{t('pages.reset-password-2.form.label.email')}</label>
            <div className="form-giris-grubu">
              <span className="form-giris-ek">
                <i className="fas fa-envelope" style={{ fontSize: 14, color: '#6b7280' }} />
              </span>
              <input
                type="email" className="form-girisi"
                placeholder={t('pages.reset-password-2.form.placeholder.email')}
                value={email} onChange={e => setEmail(e.target.value)} required
              />
            </div>
          </div>

          {/* OTP */}
          <div className="form-grubu">
            <label className="form-etiketi">{t('pages.reset-password-2.form.label.otp')}</label>
            <div className="form-giris-grubu">
              <span className="form-giris-ek">
                <i className="fas fa-key" style={{ fontSize: 14, color: '#6b7280' }} />
              </span>
              <input
                type="text" className="form-girisi"
                placeholder={t('pages.reset-password-2.form.placeholder.otp')}
                value={otp} onChange={e => setOtp(e.target.value)}
                maxLength={8} style={{ letterSpacing: '0.2em', fontWeight: 600 }} required
              />
            </div>
          </div>

          {/* Yeni Şifre */}
          <div className="form-grubu">
            <label className="form-etiketi">{t('pages.reset-password-2.form.label.password')}</label>
            <div className="form-giris-grubu">
              <span className="form-giris-ek">
                <i className="fas fa-lock" style={{ fontSize: 14, color: '#6b7280' }} />
              </span>
              <input
                type={sifreGoster ? 'text' : 'password'} className="form-girisi"
                placeholder={t('pages.reset-password-2.form.placeholder.password')}
                value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} required
              />
              <button
                type="button" className="form-giris-ek form-giris-ek-sag"
                onClick={() => setSifreGoster(p => !p)}
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                <i className={`fas ${sifreGoster ? 'fa-eye-slash' : 'fa-eye'}`}
                  style={{ fontSize: 14, color: '#6b7280' }} />
              </button>
            </div>
          </div>

          {/* Şifre Tekrar */}
          <div className="form-grubu">
            <label className="form-etiketi">{t('pages.reset-password-2.form.label.confirm-password')}</label>
            <div className="form-giris-grubu">
              <span className="form-giris-ek">
                <i className="fas fa-lock" style={{ fontSize: 14, color: '#6b7280' }} />
              </span>
              <input
                type={sifreGoster ? 'text' : 'password'} className="form-girisi"
                placeholder={t('pages.reset-password-2.form.placeholder.confirm-password')}
                value={yeniSifreTekrar} onChange={e => setYeniSifreTekrar(e.target.value)} required
              />
            </div>
          </div>

          <button
            type="submit"
            className="dugme dugme-birincil dugme-buyuk dugme-tam-genislik"
            disabled={yukleniyor}
            style={{ justifyContent: 'center', marginTop: 8 }}
          >
            {yukleniyor ? (
              <>
                <div className="yuklenici-cember yuklenici-cember-beyaz"
                  style={{ width: 16, height: 16, borderWidth: 2 }} />
                {t('common.please-wait')}
              </>
            ) : (
              <>
                {t('pages.reset-password-2.form.button.change')}
                <i className="fas fa-check" style={{ fontSize: 13 }} />
              </>
            )}
          </button>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Link to="/portal/login" className="auth-link" style={{ fontSize: 13 }}>
              <i className="fas fa-arrow-left" style={{ marginRight: 6 }} />
              {t('pages.reset-password-2.form.label.go-back-login')}
            </Link>
          </div>
        </form>

        <div className="auth-alt-bilgi">
          <p>© {new Date().getFullYear()} {t('footer.copyright.company-name')}</p>
        </div>
      </div>
    </AuthLayout>
  );
}
